import { get, post } from '../core/http';
import type { HomeActionBrowseParams } from './home';

export interface DashboardPageViewParams {
  pageId: number;
  sourceId?: number;
}

export interface DashboardShareParams {
  pageId: number;
  shareUrl: string;
  useCaseId: number;
}

export const dashboardApi = {
  recordActionBrowse(params: HomeActionBrowseParams) {
    return post<string, HomeActionBrowseParams>('/dashboard/front/recordAB', params);
  },

  recordShare(params: DashboardShareParams) {
    return post<string, DashboardShareParams>('/dashboard/front/recordShare', params);
  },

  recordPageView(params: DashboardPageViewParams) {
    return get<string, DashboardPageViewParams>('/dashboard/front/recordPV', params);
  },
};
